<template>
    <span
        :style="{ color: color, background: background }"
        class="tag-status"
        :class="{ circle: circle }"
        >{{ text }}</span
    >
</template>

<script>
export default {
    name: "TagStatus",
    props: {
        text: {
            type: String,
            default: "内容",
        },
        color: {
            type: String,
            default: "#2C8DF0",
        },
        background: {
            type: String,
            default: "rgba(0,0,0,0)",
        },
        circle: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="less" scoped>
.tag-status {
    padding: 5px 14px;
}
.circle {
    border-radius: 15px;
}
</style>
